import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { polyfill as mobileDragDropPolyfill } from 'mobile-drag-drop';

import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Enable HTML5 drag-and-drop on touch devices (iOS WebView, Android Chrome).
// holdToDrag: 250ms long-press before drag starts — prevents accidental drags
// during list scroll, matches native iOS gesture expectations.
mobileDragDropPolyfill({
  holdToDrag: 250,
  dragImageCenterOnTouch: true,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    console.log('Application started');
  })
  .catch((err) => console.error(err));
